import ListItemText from '@material-ui/core/ListItemText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import { breakpoints } from '@sorted/sorted-ui';
import colors from '../../colors';

const SubMenuTitleWrapper = styled.span`
	height: 100%;
	width: 100%;
	display: flex;
	position: relative;
	box-sizing: border-box;
	align-items: center;
	text-decoration: none;
	height: 60px;
	white-space: nowrap;
	transition: background-color 0.1s ease, color 0.1s ease;
	padding-left: 53px;

	@media (min-width: ${breakpoints.tablet}) {
		height: 90px;
		padding-left: 30px;
		padding-right: 16px;

		.settings & {
			height: 45px;
		}
	}

	span {
		padding: 0;
	}

	&.active {
		background-color: ${colors.pink};
		color: ${colors.white};
	}
`;

const useStyles = makeStyles({
	text: {
		'.MuiTypography-root': {
			whiteSpace: 'nowrap'
		}
	}
});

const SubMenuTitle = ({ title }) => {
	const classes = useStyles();

	return (
		<SubMenuTitleWrapper>
			<ListItemText className={classes.text} primary={title} />
			<FontAwesomeIcon icon={faChevronRight} size="sm" fixedWidth />
		</SubMenuTitleWrapper>
	);
};

SubMenuTitle.propTypes = {
	title: PropTypes.string.isRequired
};

export default SubMenuTitle;
